import logo from '../icon.png'

export default function Footer() {
    return (
        <div className='w-screen fixed bottom-0 left-0'>
            <div className='max-w-7xl mx-auto'>
                <div className='bg-white dark:bg-[#101010] md:ml-10 md:mb-5 md:w-fit w-full rounded-lg shadow-lg'>
                    <div className='flex gap-4 text-black dark:text-white p-2'>
                        <div>
                            <img className='w-9 h-9 rounded-full' src={logo} alt='icon' />
                        </div>
                        <span className='my-auto flex'>Made by <a className='ml-1 font-bold hover:text-sky-600 transition ease-in' href='https://tanvirbhachu.netlify.app/' target='_blank' rel='noreferrer'> Tanvir Bhachu</a></span>
                    </div>
                </div>
            </div>
        </div>
        /* <div className='max-w-7xl mx-auto flex relative bg-white'>
            <div className="fixed bottom-0 left-0 md:w-fit w-full bg-white dark:bg-[#101010] p-3 md:rounded-xl shadow-lg">
                    <div className='flex gap-4 text-black dark:text-white'>
                        <div>
                            <img className='w-9 h-9 rounded-full' src={logo} alt='icon' />
                        </div>
                        <span className='my-auto'>Made by <a className='font-bold hover:text-sky-600 transition ease-in' href='https://darksimilarity.netlify.app/' target='_blank' rel='noreferrer'>DarkSimilarity</a></span>
                    </div>
            </div>
        </div> */
    )
}
